export function isSameTrackAndPlaying(activeTrackId, trackId, isPlaying) {
	return activeTrackId && isPlaying && activeTrackId === trackId;
}